import { isEmpty } from 'lodash'
import { defineMessages } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'

// State
import { useListingSearchContext } from 'src/context/listingSearch'

// Utils
import {
  LISTING_SEARCH_ARIA_LABELLED_BY,
  PLACE_SEARCHES,
  RECENT_SEARCHES,
  SAVED_SEARCHES,
} from 'src/constants/listings'

// Components
import { Text, Unless } from 'src/Components'

// Relative Components
import PlaceIcon from './PlaceIcon'
import ClockIcon from './ClockIcon'
import Result from './Result'

// Styles
import styles from './List.module.scss'

const List = () => {
  const intl = useFormatMessage()

  const { results, resultsListId, flattenedResults } = useListingSearchContext()

  const TYPES_OF_SEARCHES = {
    default: defineMessages({
      [RECENT_SEARCHES]: {
        id: 'SearchModal.results.recentSearches',
        defaultMessage: 'Recent',
      },
      [SAVED_SEARCHES]: {
        id: 'SearchModal.results.savedSearches',
        defaultMessage: 'Saved Searches',
      },
      [PLACE_SEARCHES]: {
        id: 'SearchModal.results.placeSearches',
        defaultMessage: 'Places',
      },
    }),
  }

  const TYPES_OF_SEARCHES_MAPPING = {
    [RECENT_SEARCHES]: {
      title: intl(TYPES_OF_SEARCHES.default[RECENT_SEARCHES]),
      icon: <ClockIcon data-qa='svg-clock' />,
    },
    [SAVED_SEARCHES]: {
      title: intl(TYPES_OF_SEARCHES.default[SAVED_SEARCHES]),
      icon: <ClockIcon data-qa='svg-clock' />,
    },
    [PLACE_SEARCHES]: {
      title: intl(TYPES_OF_SEARCHES.default[PLACE_SEARCHES]),
      icon: <PlaceIcon data-qa='svg-place' />,
    },
  }

  const typesOfSearches = Object.keys(results)

  return (
    <div>
      {typesOfSearches?.map(type => (
        <Unless key={type} condition={isEmpty(results[type])}>
          <div data-qa='resultList' className={styles.top}>
            <div className={styles.container}>
              <div className={styles.searchType}>
                <div className={styles.header}>
                  {TYPES_OF_SEARCHES_MAPPING[type]?.icon}
                </div>
                <Text
                  className={styles.subHeader}
                  weight='semibold'
                  size='xxs'
                  variant='neutralWarm'
                  variantCount='500'
                  transform='uppercase'
                >
                  {TYPES_OF_SEARCHES_MAPPING[type]?.title}
                </Text>
              </div>
              <div className={styles.listContainer}>
                <ul
                  className={styles.list}
                  id={resultsListId}
                  role='listbox'
                  data-qa={resultsListId}
                  aria-labelledby={LISTING_SEARCH_ARIA_LABELLED_BY}
                >
                  {results[type]?.map(result => {
                    const index = flattenedResults.findIndex(
                      res => res.id === result.id
                    )
                    return (
                      <>
                        <Result
                          index={index}
                          key={result.id}
                          result={result}
                          type={type}
                        />
                        <Unless condition={index === results[type].length - 1}>
                          <hr className={styles.divider} />
                        </Unless>
                      </>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </Unless>
      ))}
    </div>
  )
}

export default List
